import { createContext } from 'react'
import type { Context } from 'react'
import type { PurchaseOrderStateType } from 'storeContext/reducers/purchaseOrder'
import type { PurchaseOrderDispatchType } from 'storeContext/actions/purchaseOrders/list'

export type PurchaseOrderContextValueType = {
  state: PurchaseOrderStateType
  dispatch: PurchaseOrderDispatchType
}

// Preserve the original raw-state context default and provider identity.
export const createPurchaseOrderContext = (initialState: PurchaseOrderStateType) =>
  createContext(initialState) as unknown as Context<PurchaseOrderContextValueType>
